import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { TrashIcon } from "../../ui/icons/trash";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import MultiSelectCheckbox from "../../ui/molecules/multiSelectCheckbox";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { attivita_bio, categorie_prodotti, categorie_prodotti_A, OptionType, prodotti } from "../../utils";
import { BiologicalActivityDTO } from "../clienti/feature/dto";
import { addDefaultBiologicalActivity, setCreateBiologicalActivity, setCreateBiologicalActivityActivityByIndex, setCreateBiologicalActivityCategoryByIndex, setCreateBiologicalActivityProductsByIndex, setUpdateBiologicalActivity, setUpdateBiologicalActivityActivityByIndex, setUpdateBiologicalActivityCategoryByIndex, setUpdateBiologicalActivityProductsByIndex } from "../clienti/feature/slice";

interface Props {
  mode?: "create" | "edit"
}


export function Bio({ mode }: Props) {
  const customerState = useAppSelector(state => state.customer)

  const dispatch = useAppDispatch()

  const [selectedCategories, setSelectedCategories] = useState<OptionType[][]>([])
  const [selectedProducts, setSelectedProducts] = useState<OptionType[][]>([])


  const biologicalActivity: BiologicalActivityDTO[] =
    mode === "create"
      ? (customerState.customerCreateRequest.biologicalActivity ?? [])
      : (customerState.customerUpdateRequest.biologicalActivity ?? []);

  const biologicalActivityRequest = mode === "create" ? customerState.customerCreateRequest.biologicalActivity! : customerState.customerUpdateRequest.biologicalActivity!

  useEffect(() => {
    if (customerState.getCustomerByIdResponse !== undefined && mode === "edit") {
      dispatch(setUpdateBiologicalActivity(customerState.getCustomerByIdResponse.biologicalActivity));
    }
  }, [customerState.getCustomerByIdResponse, mode]);

  useEffect(() => {
    if (biologicalActivityRequest !== null && biologicalActivityRequest.length > 0) {
      const categories = biologicalActivityRequest.map(ba => ba.category) as string[][]
      setSelectedCategories(categories as any)
      const products = biologicalActivityRequest.map(ba => ba.products) as string[][]
      setSelectedProducts(products as any)
    }
  }, [biologicalActivityRequest])

  return (
    <div className="flex flex-col gap-6 border-t border-neutral-200 pt-6">
      {
        biologicalActivity?.map((ba, index, arr) => (
          <React.Fragment key={index}>
            <div className="flex flex-col gap-4 w-full">
              <div className="flex items-center gap-3 w-full">
                <div className="grid grid-cols-2 gap-4 flex-1 items-center">
                  <MadfarmStaticSelect
                    noOptionsMessage="Nessuna attività trovata"
                    placeholder="Attività"
                    options={attivita_bio}
                    defaultValue={biologicalActivityRequest[index].activity}
                    value={biologicalActivityRequest[index].activity}
                    onChange={(value) => {
                      // @ts-ignore
                      const newValue = value !== null ? value.value : null
                      if (mode === "create")
                        dispatch(setCreateBiologicalActivityActivityByIndex({ data: newValue, index }))
                      else
                        dispatch(setUpdateBiologicalActivityActivityByIndex({ data: newValue, index }))
                    }}
                  />
                  <MultiSelectCheckbox
                    maxSelectedLabel={1}
                    onChange={(e) => {
                      const cats = [...selectedCategories]
                      cats[index] = e.value
                      setSelectedCategories(cats)
                      if (!cats[index].map(c => c.value).includes('G')) {
                        const prods = [...selectedProducts]
                        prods[index] = []
                        setSelectedProducts(prods)
                        if (mode === "create")
                          dispatch(setCreateBiologicalActivityProductsByIndex({ data: [], index }))
                        else
                          dispatch(setUpdateBiologicalActivityProductsByIndex({ data: [], index }))
                      }
                      if (mode === "create")
                        dispatch(setCreateBiologicalActivityCategoryByIndex({ data: e.value, index }))
                      else
                        dispatch(setUpdateBiologicalActivityCategoryByIndex({ data: e.value, index }))
                    }}
                    value={selectedCategories[index]}
                    option={ba.activity === 'A' ? categorie_prodotti_A : categorie_prodotti}
                    placeholder="Categoria"
                    selectAllLabel="Tutte"
                  />
                </div>
                <button
                  className="flex-shrink-0 p-2 rounded-[8px] hover:bg-neutral-200 transition-colors"
                  onClick={() => {
                    const newActivities = biologicalActivity.filter((b) => b !== ba)
                    if (mode === "create")
                      dispatch(setCreateBiologicalActivity(newActivities))
                    else
                      dispatch(setUpdateBiologicalActivity(newActivities))
                  }}
                >
                  <TrashIcon color="#8383AD" size={24} />
                </button>
              </div>

              {biologicalActivity[index].category.includes('G') && (
                <MultiSelectCheckbox
                  maxSelectedLabel={1}
                  onChange={(e) => {
                    const prods = [...selectedProducts]
                    prods[index] = e.value
                    setSelectedProducts(prods)
                    if (mode === "create")
                      dispatch(setCreateBiologicalActivityProductsByIndex({ data: e.value, index }))
                    else
                      dispatch(setUpdateBiologicalActivityProductsByIndex({ data: e.value, index }))
                  }}
                  value={selectedProducts[index]}
                  option={prodotti}
                  placeholder="Prodotti"
                  selectAllLabel="Tutte"
                />
              )}
            </div>

            {index < arr.length - 1 && (
              <div className="border-t border-neutral-200" />
            )}
          </React.Fragment>
        ))}
      <div>
        <ButtonComponent
          onClick={() => dispatch(addDefaultBiologicalActivity())}
          label="Aggiungi attività"
          size="sm"
          iconPosition="off"
          variant="outline"
          color="blue"
        />
      </div>
    </div>
  );
}
